import React from "react";
import { Link, Outlet } from "react-router-dom";
import {
  faBox,
  faBoxesPacking,
  faFileEdit,
  faFileUpload,
  faList,
  faListCheck,
  faListDots,
  faPowerOff,
  faUser,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useActions, useAuth } from "../../context/security/AuthProvider";
import "./layout.css";
import { types } from "../../reducers/security/authReducer";
import Navbar from "./Navbar";

const Layout = () => {
  const { user } = useAuth();
  const { logout } = useActions();
  const { name, laboratory_name, company_name } = user;
  return (
    <main className="main-body-app">
      <header className="header-app">
        <section className="container-fluid section-header-one white flex">
          <Navbar />

          <div className="flex">
            <img className="margin-auto"
              style={{ height: "70%" }}
              src="/images/menu/logo.png"
              alt="logo"
            />
          </div>
          <div className="flex">
            <div className="margin-auto">
              <FontAwesomeIcon
                onClick={() => logout()}
                className="app-green cursor-pointer logout-icon"
                icon={faPowerOff}
              />
            </div>
          </div>
        </section>
        <section className="container-fluid section-header-two white justify-betwen flex">
          <div className="flex font2 ">
            <span className="margin-auto">
              {" "}
              {company_name} {laboratory_name}
            </span>
          </div>
          <div className="flex font2  user-name-section">
            <div>
              {" "}
              <FontAwesomeIcon className="margin-auto" icon={faUserCircle} />
              &nbsp; &nbsp;
              <p className="margin-auto">{name}</p>{" "}
            </div>
          </div>{" "}
        </section>
      </header>
      <section className="content-app">
        <Outlet />
      </section>
    </main>
  );
};

export default Layout;
